module.exports = __webpack_public_path__ + "static/8f6adf.jpg";